module.exports = [{
      plugin: require('/home/chun/Development/workspace/flyacademia-home/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/chun/Development/workspace/flyacademia-home/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
